import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment as env } from '@env/environment';

export interface UserClientLink { Id: number; OrganizationId: number; OrganizationName: string; ExternalId: string; }
export interface ClientLinkOrganization { Id: number; Name: string; OrgNumber: string; }
export interface ClientLinkInput { OrganizationId: number; ExternalId: string; }

@Injectable({ providedIn: 'root' })
export class UserClientLinkService {
  constructor(private http: HttpClient) {}
  private url(userId: string) { return env.hostApi + 'Users/' + encodeURIComponent(userId) + '/ClientLinks'; }
  list(userId: string) { return this.http.get<UserClientLink[]>(this.url(userId)); }
  search(userId: string, term: string) {
    return this.http.get<ClientLinkOrganization[]>(this.url(userId) + '/Organizations', { params: { term } });
  }
  save(userId: string, id: number | null, input: ClientLinkInput) {
    return id === null ? this.http.post(this.url(userId), input) : this.http.put(this.url(userId) + '/' + id, input);
  }
  remove(userId: string, id: number) { return this.http.delete(this.url(userId) + '/' + id); }
}
